export default function forceReflow(element) {
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
}
//# sourceMappingURL=forceReflow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/forceReflow.js
// module id = 505
// module chunks = 0 1